module.exports = __webpack_public_path__ + "fonts/AvenirNext-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Avenir_Next/AvenirNext-Medium.woff
// module id = 3474
// module chunks = 0